document.documentElement.classList.add('mbe-js');
const mbeObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
  if (entry.isIntersecting) { entry.target.classList.add('mbe-is-visible'); mbeObserver.unobserve(entry.target); }
}), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
document.querySelectorAll('[data-mbe-reveal]').forEach((element) => mbeObserver.observe(element));

// Typewriter reveal on key titles — a quiet nod to handwriting, only when motion is welcome.
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-mbe-typewriter]');
  if (!targets.length || reducedMotion) return;

  function typewriterize(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) textNodes.push(node);
    var chars = [];
    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < text.length; i++) {
        var span = document.createElement('span');
        span.className = 'mbe-tw-char';
        span.textContent = text[i];
        frag.appendChild(span);
        chars.push(span);
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return chars;
  }

  var twObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      twObserver.unobserve(entry.target);
      var chars = typewriterize(entry.target);
      chars.forEach(function (span, i) {
        setTimeout(function () { span.classList.add('is-visible'); }, i * 22);
      });
    });
  }, { rootMargin: '0px 0px -15% 0px', threshold: 0.3 });

  targets.forEach(function (el) { twObserver.observe(el); });
})();
